import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { FilledLinkToWebField } from '@prismicio/client';
import { BrandService } from 'brand';
import { SvgComponent } from 'icon';
import { LinkComponent } from 'link';
import { TranslateService } from 'translate';
import { PhoneNumberSlice } from './phone-number.slice';

@Component({
  selector: 'app-phone-number',
  templateUrl: './phone-number.component.html',
  imports: [LinkComponent, SvgComponent, NgClass],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhoneNumberComponent implements OnInit {
  brand = inject(BrandService);
  private translateService = inject(TranslateService);
  @Input() slice: PhoneNumberSlice;
  ariaLabel: string;
  icon: string;
  validPrismicData = true;

  ngOnInit(): void {
    if ((this.slice.link as FilledLinkToWebField).url === undefined || this.slice.phone_number === '') {
      this.validPrismicData = false;
      console.warn('Invalid data on Prismic for PhoneNumber slice. Fields "Phone number" and "Link" are required.');
    }
    const alternative_text = this.slice.alternative_text || '';
    const phoneNumber = (this.slice.link as FilledLinkToWebField).url?.substring(4);
    this.ariaLabel = `${this.translateService.getTranslation([
      'telephoneNumber',
    ])}. ${phoneNumber}. ${alternative_text}`;

    this.icon =
      this.slice.icon === 'cable-phone'
        ? this.brand.isYallo()
          ? 'cable-phone'
          : 'cable-phone-darkblue'
        : this.slice.icon;
  }
}
